import * as fromDatatype from '../datatype-library/index'

export interface bl_mrp_prodsys_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    prodsys_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
    prodsys_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision:fromDatatype.RevisionDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}


export class bl_mrp_prodsys_link_RowClass implements bl_mrp_prodsys_link_RowInterface
  {
    guid: fromDatatype.GuidDataFieldInterface;
    prodsys_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
    prodsys_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision:fromDatatype.RevisionDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
